<template>
  <div class="tabSupplementInfo">
    <v-form
      v-model="fapi"
      :conponentsList="conponentsList"
      :rule="configList"
    />
  </div>
</template>

<script>
import Contract from '@/components/Contract.vue';
import ContractFold from '@/components/ContractFold.vue';
import Separator from '@/components/Separator.vue';
import { mapMutations, mapState } from 'vuex';
import PlaceOrderButton from '../common/PlaceOrderButton.vue';
import Input from '../common/Input.vue';
import LoanAmountInput from '../common/LoanAmountInput.vue';
import Identity from '../common/Identity.vue';
import SelectInput from '../common/SelectInput.vue';
import BWSelect from '../common/BWSelect.vue';
import CascadePicker from '../common/CascadePicker.vue';
import LivingPlacePicker from '../common/LivingPlacePicker.vue';
import ApplicationType from '../common/ApplicationType.vue';
import SuffixInput from '../common/SuffixInput.vue';
import InputIsShow from '../common/InputIsShow.vue';
import LegalPersonInput from '../common/LegalPersonInput.vue';

export default {
  name: 'tabSupplementInfo',
  props: {
    configList: {
      type: Array,
      default: () => [],
    },
    perfectOrderInfo: {},
  },
  data() {
    return {
      loading: false,
      isDisabled: true,
      conponentsList: [
        Input,
        Contract,
        ContractFold,
        SelectInput,
        ApplicationType,
        BWSelect,
        CascadePicker,
        Identity,
        LoanAmountInput,
        LivingPlacePicker,
        PlaceOrderButton,
        SuffixInput,
        InputIsShow,
        LegalPersonInput,
        Separator
      ],
      fapi: {},
      list: [],
    };
  },
  watch: {
    perfectOrderInfo: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.fapi.setInitialValues(val);
        }
      },
    },
    'publicPage.borrowerType': {
      handler(n) {
        if (n === '1') {
          this.fapi.setInitialValues({
            legalIdentity: '',
            legalName: '',
            legalPhone: '',
          });
        } else if (n === '2' || n === '3') {
          this.fapi.setInitialValues({
            legalIdentity: '',
            legalName: '',
            legalPhone: '',
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.fapi.onFinishFailed(() => {
      this.isDisabled = this.fapi.passThrough;
      const obj = this.fapi.getState();
      this.updateState({
        submitInfoAll: {
          ...this.publicPage.submitInfoAll,
          ...obj,
        },
      });
      if (!this.fapi.passThrough) {
        this.$emit('input', obj);
      } else {
        this.$emit('input', null);
      }
    });
  },
};
</script>
<style scoped>
.tabSupplementInfo {
  padding-bottom: 100px;
}
/* .tabSupplementInfo >>> .bizAddress, 
.tabSupplementInfo >>> .borrowerAddress, 
.tabSupplementInfo >>> .iceContactName, 
.tabSupplementInfo >>> .iceContactPhone, 
.tabSupplementInfo >>> .iceContactIdentity, 
.tabSupplementInfo >>> .borrowerEmail{
  margin-right: 28px;
} */
</style>
